import TrainInfoPart from './train-info-part';

export default TrainInfoPart;